"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getWidgetHandler", {
    enumerable: true,
    get: function() {
        return getWidgetHandler;
    }
});
const _basewidgethandler = require("~/db/widgets/base-widget.handler");
async function getWidgetHandler(..._params) {
    return new _basewidgethandler.BaseWidgetHandler();
}
